import type { IconData } from '@stacksjs/iconify-core'

export const borderAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.5 20.5a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2h-15v15a1 1 0 0 1-1 1\"/><circle cx=\"19.5\" cy=\"11.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"19.5\" cy=\"7.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"19.5\" cy=\"15.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"7.5\" cy=\"19.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"11.5\" cy=\"19.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"15.5\" cy=\"19.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"19.5\" cy=\"19.5\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default borderAlt
